import { useState } from "react";

import noop from "lodash/noop";

import { SWReactIcons } from "@similarweb/icons";
import { BasicModal, Button, Checkbox, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { Title } from "app/pages/activation/components/Settings/UnsavedModal/styles";

import { generateAutomationName } from "../../../helpers/generateAutomationName";

import { modalConfig, TOOLTIP_WIDTH } from "./config";
import * as SC from "./styles";
import { deleteModalTexts } from "./texts";

type DeleteModalSchema = {
    isOpen: boolean;
    topicsCount: number;
    onCancel: () => void;
    onDelete: (shouldRemoveKWList: boolean) => void;
};

const DeleteModal = ({ isOpen, topicsCount, onCancel, onDelete }: DeleteModalSchema) => {
    const [shouldRemoveKW, setShouldRemoveKW] = useState(false);

    const onCheckboxClick = () => {
        setShouldRemoveKW((isSelected) => !isSelected);
    };

    const handleDelete = () => {
        onDelete(shouldRemoveKW);
    };

    return (
        <BasicModal
            isOpen={isOpen}
            onRequestClose={onCancel}
            customStyles={modalConfig}
            closeIconConfig={{
                show: false,
                onClick: noop,
            }}
        >
            <SC.HeaderTitle>
                <Title data-automation={generateAutomationName("settings", ["delete", "modal", "title", "wrapper"])}>
                    {translate(deleteModalTexts.title)}
                </Title>
            </SC.HeaderTitle>
            <SC.ModalContent
                data-automation={generateAutomationName("settings", ["delete", "modal", "content", "wrapper"])}
            >
                <SC.TextWrapper>{translate(deleteModalTexts.body)}</SC.TextWrapper>
                <Checkbox
                    selected={shouldRemoveKW}
                    onClick={onCheckboxClick}
                    isDisabled={!topicsCount}
                    label={
                        <SC.CheckWrapper>
                            {translate(deleteModalTexts.checkLabel)}
                            <PlainTooltip
                                maxWidth={TOOLTIP_WIDTH}
                                enabled={!!topicsCount}
                                tooltipContent={translate(deleteModalTexts.tooltipText, { count: topicsCount })}
                            >
                                <SC.TooltipWrapper>
                                    <SWReactIcons
                                        size="xs"
                                        iconName="info"
                                    />
                                </SC.TooltipWrapper>
                            </PlainTooltip>
                        </SC.CheckWrapper>
                    }
                />
            </SC.ModalContent>
            <SC.ButtonGroup
                data-automation={generateAutomationName("settings", ["delete", "modal", "buttons", "wrapper"])}
            >
                <Button
                    type="flat"
                    onClick={onCancel}
                >
                    {translate(deleteModalTexts.cancel)}
                </Button>
                <Button
                    type="warning"
                    onClick={handleDelete}
                >
                    {translate(deleteModalTexts.delete)}
                </Button>
            </SC.ButtonGroup>
        </BasicModal>
    );
};

export default DeleteModal;
